import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import type { PayorChangeEventProps } from '../../model'
import { FieldsGrid } from '../shared'

export function PayorChangeEvent({
  event,
  searchQuery,
}: {
  event: PayorChangeEventProps
  searchQuery: string
}) {
  return (
    <div className="flex flex-col gap-0.5 py-[3px]">
      <Text appearance="SUBTITLE2">{highlightText(event.title, searchQuery)}</Text>
      {event.fields ? (
        <FieldsGrid
          fields={event.fields}
          searchQuery={searchQuery}
          userRole={event.userRole}
        />
      ) : null}
    </div>
  )
}
